import React from "react";

function TradeSummary(props) {
  const { data, seg, selection, totalValues } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tradeSummar-Wrapper">
        <table className="table last-column">
          <thead>
            {selection === "date" && (
              <tr className="">
                <th scope="col">DATE</th>
                <th scope="col">Symbol</th>
                {seg === "stocks" && <th scope="col">ISIN</th>}
                <th scope="col">Exchange</th>
                <th scope="col">Quantity</th>
                <th scope="col">Price</th>
                <th scope="col">Order Value</th>
                {seg === "curfo" && <th scope="col">Action</th>}
                {seg === "curfo" && <th scope="col">Lot Size</th>}
                {seg === "stocks" && <th scope="col">Remark</th>}
                {seg === "stocks" && <th scope="col">Flag</th>}
              </tr>
            )}
            {selection === "script" && (
              <>
                <tr className="for-trade1">
                  <th colSpan={1}>scrip</th>
                  <th scope="col" className="" colSpan={3}>
                    BUY
                  </th>
                  <th scope="col" className="" colSpan={3}>
                    SELL
                  </th>
                  <th scope="col" className="" colSpan={2}>
                    NET
                  </th>
                </tr>
                <tr className="for-trade2">
                  <th scope="col"></th>

                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                  <th scope="col">Avg</th>
                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                  <th scope="col">Avg</th>
                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                </tr>
              </>
            )}
          </thead>

          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    {selection === "date" && (
                      <tr key={key}>
                        <td>{item?.date || "-"}</td>
                        <td>
                          {`${item?.symbol || "-"} (${item?.action || "-"})`}
                        </td>
                        {seg === "stocks" && <td>{item?.isin || "-"}</td>}
                        <td>{item?.exchange || "-"}</td>
                        <td>{item?.quantity || 0}</td>
                        <td>{item?.Price || 0}</td>
                        <td>{item?.orderValue || 0}</td>
                        {seg === "curfo" && <td>{item?.action || 0}</td>}
                        {seg === "curfo" && <td>{item?.lotSize || 0}</td>}
                        {seg === "stocks" && <td>{item?.remark || 0}</td>}
                        {seg === "stocks" && <td>{item?.flag || 0}</td>}
                        {/* <td>{}</td> */}
                      </tr>
                    )}
                    {selection === "script" && (
                      <tr key={key} className="for-script2">
                        <td>{item?.scrip || "-"}</td>
                        <td>{item?.buyQty || 0}</td>
                        <td>{item?.buyValue || 0}</td>
                        <td>{item?.buyAvg || 0}</td>
                        <td>{item?.sellQty || 0}</td>
                        <td>{item?.sellValue || 0}</td>
                        <td>{item?.sellAvg || 0}</td>
                        <td>{item?.netQty || 0}</td>
                        <td>{item?.netValue || 0}</td>
                      </tr>
                    )}
                  </>
                );
              })}
          </tbody>
          {selection === "script" && (
            <tbody className="tradeSummary-table-body-total">
              <tr>
                <td>Total</td>
                <td colSpan={3}>{totalValues.totaBuylValue}</td>
                <td colSpan={3}>{totalValues.totalSellValue}</td>
                <td colSpan={2}>{totalValues.totalNetValue}</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </>
  );
}
export default TradeSummary;
